// /Interview for single batch

import * as React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Calendar, AlertCircle } from 'lucide-react';
import { InterviewData, InterviewListProps } from '@/lib/interviewTypes';
import InterviewCard from './InterviewCard';

const InterviewList: React.FC<InterviewListProps> = ({ 
    interviews,
    title = 'Scheduled Interviews',
    error,
    batchInfo,
    showInstructor = false,
    emptyMessage = 'No interviews scheduled yet.',
    editInterview = false
   
}) => {
    return (
        <Card>
            <CardHeader>
                <CardTitle className="text-xl font-bold flex items-center gap-2">
                    <Calendar className="w-5 h-5" />
                    {title}
                </CardTitle>
            </CardHeader>
            <CardContent>
                {error && (
                    <div className="mb-4 p-4 bg-red-50 border border-red-200 rounded-lg">
                        <p className="text-red-600 text-sm">
                            Error loading interviews: {error?.data?.message || error?.message || 'Unknown error'}
                        </p>
                        {batchInfo?._id && (
                            <p className="text-red-500 text-xs mt-1">
                                Batch Code used: {batchInfo._id}
                            </p>
                        )}
                    </div>
                )}
                {interviews.length === 0 ? (
                    <div className="text-center py-8 text-gray-500">
                        <Calendar className="w-12 h-12 mx-auto text-gray-400 mb-4" />
                        <p>{emptyMessage}</p>
                        {batchInfo && (
                            <p className="text-xs text-gray-400 mt-2">
                                Batch: {batchInfo.bCode} {batchInfo._id && `(ID: ${batchInfo._id})`}
                            </p>
                        )}
                    </div>
                ) : (
                    <div className="space-y-4">
                        {interviews.map((interview: InterviewData) => (
                            <InterviewCard 
                                key={interview._id} 
                                interview={interview}
                                showInstructor={true}
                            />
                        ))}
                    </div>
                )}
            </CardContent>
        </Card>
    );
};

export default InterviewList;

